import { LocalContext } from "context/AuthenticationContext";
import { DependenciesInjection } from "di/DependencyInjection";
import { Component, ContextType } from "react";
import { BaseViewModel } from "./BaseViewModel";

export interface IBaseViews {
  token: string | symbol;
  addtionalProps?: unknown;
}

export abstract class BaseViews<
  VM extends BaseViewModel<Disposable, Disposable>,
  S extends Object,
  SS extends Object
> extends Component<IBaseViews & S, SS> {
  static contextType = LocalContext;
  context: ContextType<typeof LocalContext>;
  viewModel: VM;

  constructor(props: IBaseViews & S) {
    super(props);
    this.viewModel = DependenciesInjection.lateResolution<VM>(this.props.token);
    this.bindViewModel = this.bindViewModel.bind(this);
  }

  protected bindViewModel(): void {
    this.viewModel.context = this.context;
  }

  protected dispose(): void {}

  componentDidMount(): void {
    this.bindViewModel();
  }

  componentWillUnmount(): void {
    this.dispose();
    if (typeof this.viewModel[Symbol.dispose] === "function") {
      this.viewModel[Symbol.dispose]();
    }
  }
}
